const filterKeyBasicInfo = {
  ACCOUNT: "account",
  ACCOUNT_ID: "account_id",
  ROLE: "role",
  REGISTER_START_DATE: "register_start_date",
  REGISTER_END_DATE: "register_end_date",
  AGENT_REVIEWED_START_DATE: "agent_reviewed_start_date",
  AGENT_REVIEWED_END_DATE: "agent_reviewed_end_date",
};

const filterKeyUserData = {
  ACCOUNT: "account",
  ACCOUNT_ID: "account_id",
  SETTLED_START_DATE: "settled_start_date",
  SETTLED_END_DATE: "settled_end_date",
};

const filterKeyAgentData = {
  ACCOUNT: "account",
  INVITE_CODE: "invite_code",
  START_DATE: "start_date",
  END_DATE: "end_date",
};

const filterKeyMemberData = {
  ACCOUNT: "account",
  SETTLED_START_DATE: "settled_start_date",
  SETTLED_END_DATE: "settled_end_date",
  IS_AGENT: "is_agent",
  LEVEL: "level",
};

const filterKeyMemberBetAmountData = {
  ACCOUNT: "account",
  AGENT_ACCOUNT: "agent_account",
  SETTLED_START_DATE: "settled_start_date",
  SETTLED_END_DATE: "settled_end_date",
  IS_AGENT: "is_agent",
  LEVEL: "level",
};

export {
  filterKeyAgentData,
  filterKeyBasicInfo,
  filterKeyMemberBetAmountData,
  filterKeyMemberData,
  filterKeyUserData,
};
